import React from "react";
import { DialogActions, Box } from "@mui/material";
import { useModalClasses } from "./Modal.style.js";
const ModalFooter = ({ infoMessage, children }) => {
  const { classes } = useModalClasses();
  return /* @__PURE__ */ React.createElement(DialogActions, { className: classes.modalActions }, /* @__PURE__ */ React.createElement(Box, { className: classes.modalSubInfoMessageContainer }, infoMessage), /* @__PURE__ */ React.createElement(Box, { className: classes.modalActionsButtonsContainer }, children));
};
export {
  ModalFooter
};
//# sourceMappingURL=ModalFooter.js.map
